import { render, staticRenderFns } from "./ClientesConecta.vue?vue&type=template&id=a9d2ab44&"
import script from "./ClientesConecta.vue?vue&type=script&lang=ts&"
export * from "./ClientesConecta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports